import { api } from "@/api/axios.ts";
import {
  ApiEvent,
  ApiEventsBusyFilter,
  ApiEmployeeBusyIntervals,
  ApiEventAttendeeResponseStatuses,
  ApiEventFilter,
  ApiEventSavePayload,
} from "@/types/event.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

export const apiEvents = {
  busy: (filter: ApiEventsBusyFilter, signal: AbortSignal) => {
    return api.post<ApiEmployeeBusyIntervals[]>("/api/v1/events/busy", filter, signal);
  },
  filter: async function (filter: ApiEventFilter, signal: AbortSignal) {
    return api.post<ApiEvent[]>("/api/v1/events/filter", { ...filter }, signal);
  },
  create: async function (event: ApiEventSavePayload) {
    return api.post<ApiOperationResult>("/api/v1/events", { ...event });
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/events/${id}`);
  },
  update: async function (id: number, payload: ApiEventSavePayload) {
    return api.put<ApiOperationResult>(`/api/v1/events/${id}`, payload);
  },
  getEventById: async function (id: number) {
    return api.get<ApiEvent>(`/api/v1/events/${id}`);
  },
  updateResponse: async function (id: number, response: ApiEventAttendeeResponseStatuses) {
    return api.put<ApiOperationResult>(`/api/v1/events/${id}/response`, {
      response_status: response,
    });
  },
};
